import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import TiposActividadesExtcurView from './TiposActividadesExtcurView';
import * as ROUTES from '../../../router/Routes';

const TiposActividadesExtcurModule = () => {
  return (
    <ContainerTemplate active={ROUTES.tiposActividadesExtraCur} routes={[]}>
      <TiposActividadesExtcurView />
    </ContainerTemplate>
  );
};

export default TiposActividadesExtcurModule;
